export default __webpack_public_path__ + "static/media/survey-icon.0e37b853.svg";